module.exports = __webpack_public_path__ + "static/media/attr_disease_wise.31c6cb6b.svg";